import React from "react";
import Paragraphs from "components/Paragraphs";
import Body from "components/Body";

export default function NodePageContent({ node }) {
  return (
    <article>
      <div className="mx-auto lg:max-w-screen-lg">
        {node.body?.processed && (
          <div className="prose max-w-none">
            <Body value={node.body?.processed} />
          </div>
        )}
      </div>

      {node.field_paragraphs?.length > 0 && (
        <Paragraphs paragraphs={node.field_paragraphs} />
      )}
    </article>
  );
}
